import axios from 'axios';
import qs from 'qs';
import {
	CreateModelProfileDto,
	DeviceModelProfileDto,
	ModelProfileType,
	UpdateModelProfileDto,
} from '@/features/modelProfile/modelProfile.dto';
import { ApiResult, Filter, ServiceResponse } from '../../OptimusRoutes/interfaces';

type Service = {
	get: (
		filter: Filter<ModelProfileType>,
		includeDevicesCount?: boolean
	) => Promise<ServiceResponse<ApiResult<ModelProfileType[]>>>;
	create: (profile: CreateModelProfileDto) => Promise<ServiceResponse<ModelProfileType>>;
	Delete: (id: number) => Promise<ServiceResponse>;
	update: (id: number, request: UpdateModelProfileDto) => Promise<ServiceResponse<ModelProfileType>>;
	updateDefault: (id: number, deviceModelId: number) => Promise<ServiceResponse<ModelProfileType>>;
	getDeviceModels: (filter: Filter<DeviceModelProfileDto>) => Promise<ApiResult<DeviceModelProfileDto[]>>;
	getModelProfileEvents: (deviceId: number) => Promise<ApiResult<number[]>>;
};

const get = async (
	{ skip, take, filter = {} }: Filter<ModelProfileType>,
	includeDevicesCount = false
): Promise<ServiceResponse<ApiResult<ModelProfileType[]>>> => {
	const params = { skip, take, filter: JSON.stringify(filter), includeDevicesCount };
	const { data } = await axios.get<ServiceResponse<ApiResult<ModelProfileType[]>>>(
		`/v2/model-profile?${qs.stringify(params)}`
	);

	return data;
};

const create = async (profile: CreateModelProfileDto): Promise<ServiceResponse<ModelProfileType>> => {
	const { data } = await axios.post<ServiceResponse<ModelProfileType>>(`/v2/model-profile/save`, profile);
	return data;
};
const update = async (id: number, request: UpdateModelProfileDto): Promise<ServiceResponse<ModelProfileType>> => {
	const { data } = await axios.patch<ServiceResponse<ModelProfileType>>(`/v2/model-profile/${id}/edit`, request);
	return data;
};

const updateDefault = async (id: number, deviceModelId: number): Promise<ServiceResponse<ModelProfileType>> => {
	const { data } = await axios.patch<ServiceResponse<ModelProfileType>>(
		`/v2/model-profile/${id}/default/${deviceModelId}`
	);
	return data;
};

const Delete = async (id: number): Promise<ServiceResponse> => {
	const { data } = await axios.delete<ServiceResponse>(`/v2/model-profile/${id}`);
	return data;
};

const getDeviceModels = async ({
	skip,
	take,
	filter = {},
}: Filter<DeviceModelProfileDto>): Promise<ApiResult<DeviceModelProfileDto[]>> => {
	const params = { skip, take, filter: JSON.stringify(filter) };
	const { data } = await axios.get<ServiceResponse<ApiResult<DeviceModelProfileDto[]>>>(
		`/v2/model-profile/device-models?${qs.stringify(params)}`
	);
	if (!data.error && data.success) {
		return data.success;
	}
	return {
		count: 0,
		data: [],
	};
};
const getModelProfileEvents = (deviceId: number): Promise<ApiResult<number[]>> => {
	return axios.get(`/v2/model-profile/device/${deviceId}/events`).then((response) => response.data);
};

const ModelProfileService: Service = {
	get,
	create,
	Delete,
	update,
	updateDefault,
	getDeviceModels,
	getModelProfileEvents,
};

export default ModelProfileService;
